/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars, copyToClipboard } from './util.js';
import { $ } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';
import { mj } from './page-mj.js';
import { startProgress, stopProgress } from './progress-util.js';

var g_current_toast_idx = 0;
var g_info_toast_elements = [];
var g_info_toast_options = [];
const g_toast_max_elements = 3;
const g_toast_max_elements_with_callbacks = 9;
const g_toast_default_options = {
	text_type: 'text',
	timeout: 5000,
	callbacks: [],
	undoToken: null,
	undoCallback: null
};

const g_timeout_of_toast_with_undo = 10 * g_toast_default_options.timeout;
/*let callback_default = {
	title: 'test',
	callback: function(element, button) {}
};*/
export function showInfoToastWithLink( infoText, linkURL, options ) {
	let all_options = Object.assign({}, structuredClone(g_toast_default_options), options);
	let html = infoText;
	if(all_options.text_type == 'text') html = htmlspecialchars(infoText);
	if( linkURL ) {
		html += '<br>'
			+'<a class="link toast-link" target="_blank" href="'+htmlspecialchars(linkURL,true,true)+'">'
			+ htmlspecialchars(linkURL)
			+'</a>';
	}

	const buttonCopy2Clipboard = all_options.buttonCopy2Clipboard ?? false;
	if( buttonCopy2Clipboard ) {
		all_options.callbacks.push(
			{
				title: mjt('md-link-info-copy'),
				callback: function( $element, $button ) {
					$button.find('.label').html('<span class="icon"></span>'+htmlspecialchars(mjt('md-link-info-copied')));
					copyToClipboard(linkURL);
					setTimeout( function() {
						$button.find('.label').text(htmlspecialchars(mjt('md-link-info-copy')));
						$button.hide().show(0);
					}, 3000 );
				}
			}
		);
	}
	all_options.text_type = 'html';
	return showInfoToast(html, all_options);
}
export function showInfoToast( infoText, options ) {
	let all_options = Object.assign({}, structuredClone(g_toast_default_options), options);
	if(all_options.text_type ==='text') infoText = htmlspecialchars(infoText);
	if(all_options.undoCallback) {
		if( all_options.timeout === g_toast_default_options.timeout ) {
			all_options.timeout = g_timeout_of_toast_with_undo;
		}
		all_options.callbacks.push(
			{
				title: mjt('revert'),
				callback: function( $element, $button ) {
					startProgress();
					$.postJSON2(mj.webroot+'json/media/undo-undo', {token: all_options.undoToken}, function(j) {
						stopProgress();
						const undoDone = function( j, options ) {
							if( j && j.success ) {
								options.undoCallback();
							} else if( j.error )  {
								showWarningToast(j.error);
								_destroy_undoToken(options.undoToken);
							}
						};
						_removeToast(
							$element,
							'undoDone',
							true,
							function _undoDoneRemoveToastDoneCb( idx, type, options ) {
								undoDone(j,options);
							},
							function _undoDoneRemoveToastErrCb() {
								undoDone(j,all_options);
							}
						);
					});
				}
			}
		);
	}
	return _showToast('info', infoText, all_options);
}
export function showErrorToast( errorText, options ) {
	let all_options = Object.assign({}, structuredClone(g_toast_default_options), options);
	all_options.timeout = 0;
	if(all_options.text_type ==='text') errorText = htmlspecialchars(errorText);
	return _showToast('error', errorText, all_options);
}
export function showWarningToast( warnText, options ) {
	let all_options = Object.assign({}, structuredClone(g_toast_default_options), options);
	all_options.timeout = 0;
	if(all_options.text_type ==='text') warnText = htmlspecialchars(warnText);
	return _showToast('warning', warnText, all_options);
}

function _destroy_undoToken(token) {
	$.postJSON2(mj.webroot+'json/media/undo-clean', {token: token}, function(j) {
	});
}




function _removeToast( $thisToastElem, reasonText, skipUndoToken, doneCb, errCb ) {
	if( $thisToastElem==null ) {
		// skip ..
		if( errCb ) {
			errCb();
		}
		return;
	}
	const thisToastElemData = $thisToastElem.data();
	const thisToastElemIdx = thisToastElemData.idx ?? 0;
	const thisToastElemType = thisToastElemData.type ?? '';
	const thisToastElemTimer = thisToastElemData.timer ?? 0;
	const thisToastElemOptions = g_info_toast_options[thisToastElemIdx] ?? null;

	// console.log({
	// 	w:'_removeToast',
	// 	thisToastElemIdx,
	// 	reasonText,
	// 	skipUndoToken,
	// 	undoToken: JSON.stringify(thisToastElemOptions?(thisToastElemOptions.undoToken??null):null),
	// 	thisToastElemType,
	// 	thisToastElemTimer,
	// 	thisToastElemOptions,
	// });

	if( thisToastElemTimer ) {
		clearTimeout(thisToastElemTimer);
	}

	if( thisToastElemType === 'info' ) {
		if( (g_info_toast_elements[thisToastElemIdx]??null)!=null ) {
			g_info_toast_elements[thisToastElemIdx].remove();
		}
		g_info_toast_elements[thisToastElemIdx] = null;
		g_info_toast_options[thisToastElemIdx] = null;
	} else {
		$thisToastElem.remove();
	}

	if( !skipUndoToken && thisToastElemOptions && thisToastElemOptions.undoToken ) {
		_destroy_undoToken(thisToastElemOptions.undoToken);
	}
	if( doneCb ) {
		doneCb(thisToastElemIdx,thisToastElemType,thisToastElemOptions);
	}
}

function _addNewToast( $newToastElem, options ) {
	$newToastElem.attr('data-idx',g_current_toast_idx);

	g_info_toast_elements[g_current_toast_idx] = $newToastElem;
	g_info_toast_options[g_current_toast_idx] = options;

	g_current_toast_idx = (g_current_toast_idx+1) % g_toast_max_elements;
}


function _createNewToastElem( idx, type, html, options ) {
	let $newToastElem = $('<div class="toast-element"'
							+' data-type="'+type+'"'
							+' data-idx="'+idx+'"'
							+' data-timeout="'+(options.timeout??0)+'"'
							+'>'
							+'<div class="'+type+'"></div>'
							+'<div class="content">'+html+'</div>'
							+'<div class="close"></div>'
						+'</div>');
	$newToastElem.on( 'click', '.close', function() {
		const $thisToastElem = $(this).closest('.toast-element');
		_removeToast($thisToastElem,'click');
	} );
	return $newToastElem;
}


function _showToast( type, html, options ) {
	if( mj.info_hook ) {
		mj.info_hook.apply(this, Array.prototype.slice.call(arguments));
	}

	let $newToastElem = _createNewToastElem(g_current_toast_idx,type,html,options);

	if( type === 'info' ) {

		// find a slot (preferably one without a "revert" callback )...
		while( g_current_toast_idx < g_toast_max_elements_with_callbacks ) {
			const prevToastOptions = g_info_toast_options[g_current_toast_idx] ?? null;
			if( prevToastOptions===null ) {
				break; // free slot
			}
			if( !prevToastOptions.callbacks.length || prevToastOptions.callbacks.length===0 ) {
				break; // slot without callbacks -> accept
			}
			// try next slot
			++ g_current_toast_idx;
		}

		const $prevToastElem = g_info_toast_elements[g_current_toast_idx] ?? null;
		_removeToast($prevToastElem,'replaceSlot');
		options._dbg_type = type;
		options._dbg_html = html;
		options._dbg_g_current_toast_idx = g_current_toast_idx;

		_addNewToast($newToastElem,options);
	}

	$('#toast').append($newToastElem);

	if( options.timeout ) {
		const timer = setTimeout( function _toastTimedOut() {
			_removeToast($newToastElem,'timeout');
		}, options.timeout * (options.callbacks.length ? 3 : 1) );
		$newToastElem.data('timer',timer);
	}

	if( options.callbacks.length ) {
		for( let i=0; i<options.callbacks.length; i++ ) {
			const entry = options.callbacks[i];
			const $button = $('<button class="" type="button"><span class="left"></span><span class="label">'
					+htmlspecialchars(entry.title)
					// +'<span class="small">: '+JSON.stringify(options.undoToken)+'</span>'
					+'</span><span class="right"></span></button>');
			$button.on('click', function() {
				const $thisButton = $(this);
				const $thisToastElem = $thisButton.closest('.toast-element');
				// console.log({w:'callback click',entry, $newToastElem,$thisToastElem, $button,$thisButton});
				entry.callback($thisToastElem,$thisButton);
			} );
			if( i===0 ) $button.addClass('primary_action');
			else $button.addClass('secondary_action');
			$button.insertBefore($newToastElem.find('.close'));
		}
	}
	return true;
}


